export const ALERT_STATES = {
  SUCCESS_ALERT: 'successAlert',
  ERROR_ALERT: 'errorAlert',
  WARNING_ALERT: 'warningAlert'
}
